var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DispensacaoForm',{ref:"DispensacaoForm",attrs:{"form":_vm.form,"model":_vm.model},on:{"save":function($event){return _vm.handleSave()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }